import api from './api';

class LoanService {
  async getAllLoans(params = {}) {
    const response = await api.get('/loans', { params });
    return response.data;
  }

  async getLoan(id) {
    const response = await api.get(`/loans/${id}`);
    return response.data;
  }

  async createLoan(loanData) {
    const response = await api.post('/loans', loanData);
    return response.data;
  }

  async simulateLoan(loanData) {
    const response = await api.post('/loans/simulate', loanData);
    return response.data;
  }

  async updateLoan(id, loanData) {
    const response = await api.put(`/loans/${id}`, loanData);
    return response.data;
  }

  async approveLoan(id, approvalData) {
    const response = await api.post(`/loans/${id}/approve`, approvalData);
    return response.data;
  }

  async disburseLoan(id, disbursementData) {
    const response = await api.post(`/loans/${id}/disburse`, disbursementData);
    return response.data;
  }

  async validateGuarantees(id, data) { return (await api.post(`/loans/${id}/validate-guarantees`, data)).data; }
  async rejectLoan(id, data) { return (await api.post(`/loans/${id}/reject`, data)).data; }
  async cancelLoan(id, data) { return (await api.post(`/loans/${id}/cancel`, data)).data; }
  async markDefault(id, data) { return (await api.post(`/loans/${id}/mark-default`, data)).data; }
  async closeLoan(id, data = {}) { return (await api.post(`/loans/${id}/close`, data)).data; }
  async restructureLoan(id, data) { return (await api.post(`/loans/${id}/restructure`, data)).data; }
  async getLoanHistory(id) { return (await api.get(`/loans/${id}/history`)).data; }
  async getLoanDocuments(id) { return (await api.get(`/loans/${id}/documents`)).data; }
  async addLoanDocument(id, data) { return (await api.post(`/loans/${id}/documents`, data)).data; }
  async getRepaymentReceipt(loanId, repaymentId) {
    return (await api.get(`/loans/${loanId}/repayments/${repaymentId}/receipt`)).data;
  }
  async exportSchedule(id) {
    const response = await api.get(`/loans/${id}/schedule/export`, { responseType: 'blob' });
    const url = window.URL.createObjectURL(response.data);
    const link = document.createElement('a');
    link.href = url;
    link.download = `echeancier-${id}.csv`;
    link.click();
    window.URL.revokeObjectURL(url);
  }

  async getLoanSchedule(id) {
    const response = await api.get(`/loans/${id}/schedule`);
    return response.data;
  }

  async getLoanStatistics() {
    const response = await api.get('/loans/statistics');
    return response.data;
  }

  async getOverdueLoans() {
    const response = await api.get('/loans/overdue');
    return response.data;
  }

  async getLoanProducts(params = {}) {
    const response = await api.get('/loans/products', { params });
    return response.data;
  }

  async createLoanProduct(productData) {
    const response = await api.post('/loans/products', productData);
    return response.data;
  }

  async updateLoanProduct(id, productData) {
    const response = await api.put(`/loans/products/${id}`, productData);
    return response.data;
  }

  async deleteLoanProduct(id) {
    const response = await api.delete(`/loans/products/${id}`);
    return response.data;
  }
}

export default new LoanService();
